import React from 'react';

import { observer } from 'mobx-react';
import { reverse } from 'named-urls';
import { useNavigate } from 'react-router-dom';

import ActionCell, { ActionConfig } from 'components/Grid/components/ActionCell';
import { ColumnActions } from 'components/Grid/types';
import routes from 'core/routes';
import { useStore } from 'utils/hooks/store';

import { ScheduleItem, getItemName } from '../ActionsSchedulesTable/ActionsSchedulesTable';

const TasksActionCell: React.FC<{
  rowData: ScheduleItem;
  actions: ColumnActions;
}> = ({ rowData, actions }) => {
  const { taskDetails } = useStore();
  const navigate = useNavigate();

  const handleDelete = async (): Promise<void> => {
    await taskDetails.deleteTask(rowData.uuid as string);
    await actions.refreshData();
  };

  const actionConfigs: ActionConfig[] = [
    {
      id: 'edit-button',
      label: 'Edit',
      onClick: () => {
        if (rowData.type === 'audit') {
          navigate(
            reverse(routes.dashboard.tasks.scheduleInstance, {
              scheduleId: rowData.schedule?.uuid as string,
              instanceId: rowData.id as string,
            })
          );
        } else {
          navigate(reverse(routes.dashboard.tasks.details, { taskId: rowData.uuid as string }));
        }
      },
    },
    ...(rowData.type !== 'audit'
      ? [
          {
            id: 'remove-button',
            label: 'Delete',
            onClick: handleDelete,
            confirmation: {
              type: 'simple' as const,
              title: 'Delete Task',
              message: 'Are you sure you want to delete this record?',
            },
          },
        ]
      : []),
  ];

  return <ActionCell actions={actionConfigs} recordName={getItemName(rowData)} />;
};

export default observer(TasksActionCell);
